import React from 'react';
import { IconProps } from './typing';

const PinFilled = ({ iconSize = 24, background = 'none', color = 'currentColor' }: IconProps) => (
  <svg
    width={iconSize}
    height={iconSize}
    viewBox={`0 0 ${iconSize} ${iconSize}`}
    fill={background}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.00195 9.50521C4.00195 4.79932 7.23076 1.60156 12 1.60156C16.7691 1.60156 19.998 4.79932 19.998 9.50521C19.998 12.6008 17.5148 16.7719 12.5878 22.1392C12.2716 22.4837 11.7283 22.4837 11.4121 22.1392C6.48513 16.7719 4.00195 12.6008 4.00195 9.50521ZM12.1134 7.2022L12.0036 7.19956L11.8938 7.20186C10.6199 7.2573 9.60289 8.30613 9.59995 9.5941C9.59995 10.9208 10.6732 11.9965 11.9992 11.9996C13.3247 11.9996 14.3989 10.9262 14.4 9.60138C14.4009 8.31341 13.3871 7.2615 12.1134 7.2022Z"
      fill={color}
    />
  </svg>
);

export default PinFilled;
